// extracted by mini-css-extract-plugin
module.exports = {"header":"Pre_header__3dcJH","pre":"Pre_pre__hNLJo","normal":"Pre_normal__1M_tQ","break":"Pre_break__3tmwY"};